import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedMapItem: null,
  showManagementHeaderBtn: false,
  showDirectorGestionBtn: false,
  showMarketingPromotionManagementBtn: false,
  showWalletBtn: false
};

const dataSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    setSelectedMapItem: (state, action) => {
      state.selectedMapItem = action.payload;
    },
    resetSelectedMapItem: (state) => {
      state.selectedMapItem = null;
    },
    changeManagementHeaderBtnState: (state, action) => {
      state.showManagementHeaderBtn = action.payload;
    },
    changeDirectorGestionBtnState: (state, action) => {
      state.showDirectorGestionBtn = action.payload;
    },
    changeMarketingPromotionManagementBtnState: (state, action) => {
      state.showMarketingPromotionManagementBtn = action.payload;
    },
    changeWalletBtnState: (state, action) => {
      state.showWalletBtn = action.payload;
    }
  }
});

export const {
  setSelectedMapItem,
  resetSelectedMapItem,
  changeManagementHeaderBtnState,
  changeDirectorGestionBtnState,
  changeMarketingPromotionManagementBtnState,
  changeWalletBtnState
} = dataSlice.actions;
export default dataSlice.reducer;

//showMarketingPromotionManagementBtn
